export default __webpack_public_path__ + "static/media/Giftr-Seller-Center-Logo.f16ba146.svg";